import { Directive, ElementRef, Input, HostListener, Renderer2, OnInit, EventEmitter, Output } from '@angular/core';
import { SocialAuthService } from '../socialauth.service';
import { take } from 'rxjs';

declare let AppleID: any;

@Directive({
  selector: 'login-button'
})
export class LoginButtonDirective implements OnInit {
  @Input() provider!: string;
  @Input() img!: string;
  @Input() label!: string;
  @Input() shortLabel!: string;

  @Input() locale!: string;
  @Output() buttonClick = new EventEmitter<any>();

  constructor(private el: ElementRef, private renderer: Renderer2, public socialAuthService: SocialAuthService) {}

  ngOnInit() {
    if (this.provider === 'google') {
      this.renderGoogleButton();
    } else if (this.provider === 'apple') {
      this.renderAppleButton();
    } else {
      this.renderButton();
    }
  }

  private renderButton(parent: HTMLElement = this.el.nativeElement) {
    const button = this.renderer.createElement('button');
    button.setAttribute('aria-label', this.label);

    this.renderer.addClass(button, 'sm-btn');
    this.renderer.addClass(button, 'sm-btn-behavior');
    this.renderer.addClass(button, 'sm-btn-bg-color');
    this.renderer.addClass(button, 'sm-btn-color');
    this.renderer.addClass(button, 'sm-btn-height');
    this.renderer.addClass(button, this.provider);

    if (this.provider === 'google') {
      button.setAttribute('onclick', 'handleGoogleLogin()');
    } else {
      button.setAttribute('onclick', `signIn('${this.provider}')`);
    }

    const img = this.renderer.createElement('img');
    img.setAttribute('aria-hidden', 'true');

    this.renderer.setAttribute(img, 'src', this.img);
    this.renderer.setAttribute(img, 'alt', this.provider);
    this.renderer.setAttribute(img, 'loading', 'lazy');
    this.renderer.setAttribute(img, 'height', '24');
    this.renderer.setAttribute(img, 'width', '24');

    this.renderer.appendChild(button, img);

    const label = this.renderer.createElement('span');
    label.setAttribute('class', 'full-label');
    label.setAttribute('aria-hidden', 'true');
    this.renderer.setProperty(label, 'innerHTML', this.label);
    this.renderer.appendChild(button, label);

    if (this.shortLabel) {
      const shortLabel = this.renderer.createElement('span');
      shortLabel.setAttribute('class', 'short-label');
      shortLabel.setAttribute('aria-hidden', 'true');
      this.renderer.setProperty(shortLabel, 'innerHTML', this.shortLabel);
      this.renderer.appendChild(button, shortLabel);
    }

    console.log(parent, button);
    this.renderer.appendChild(parent, button);
  }

  private renderGoogleButton() {
    if (!this.label) {
      this.label = 'Google';
    }

    const createGoogleLoginWrapper = (locale) => {
      const googleLoginWrapper = document.createElement('div');
      googleLoginWrapper.style.display = 'none';
      googleLoginWrapper.classList.add('custom-google-button');

      document.body.appendChild(googleLoginWrapper);

      google.accounts.id.renderButton(googleLoginWrapper, {
        type: 'icon',
        size: 'small',
        locale: locale
      });

      const googleLoginWrapperButton = googleLoginWrapper.querySelector('div[role=button]') as HTMLDivElement;
      if (googleLoginWrapperButton) {
        return {
          click: () => {
            googleLoginWrapperButton.click();
          }
        };
      }

      return null;
    };

    this.socialAuthService.initState.pipe(take(1)).subscribe((initialized) => {
      if (!!initialized) {
        const googleButtonWrapper = createGoogleLoginWrapper(this.locale);
        if (googleButtonWrapper) {
          window['handleGoogleLogin'] = () => {
            googleButtonWrapper.click();
          };

          // div.setAttribute('onclick', 'handleGoogleLogin()');
          this.renderButton();
        }

        return;
      }

      this.removeElement();
    });
  }

  private renderAppleButton() {
    if (!this.label) {
      this.label = 'Apple';
    }

    const options = {
      type: 'sign-in',
      mode: 'center-align',
      color: 'black',
      border: 'true',
      logoSize: 'small',
      width: '100%',
      height: '100%',
      labelPosition: 0,
      logoPosition: 0,
      borderRadius: 15,
      customButtonText: ''
    };

    this.socialAuthService.initState.pipe(take(1)).subscribe((initialized) => {
      if (!!initialized) {
        const node = document.createElement('div');
        node.classList.add(`apple-${options.type}-button`);
        node.setAttribute('id', 'appleid-signin');
        node.setAttribute('data-mode', options.mode);
        node.setAttribute('data-type', options.type);
        node.setAttribute('data-color', options.color);
        node.setAttribute('data-border', options.border);
        node.setAttribute('data-border-radius', options.borderRadius.toString());
        node.setAttribute('data-width', options.width);
        node.setAttribute('data-height', options.height);
        if (options.mode === 'left-align') {
          node.setAttribute('data-logo-size', options.logoSize);
          node.setAttribute('data-logo-position', options.logoPosition.toString());
          node.setAttribute('data-label-position', options.labelPosition.toString());
        }

        this.el.nativeElement.appendChild(node);
        AppleID.auth.renderButton();

        const btnPlace = document.getElementById('appleid-signin');
        if (btnPlace) {
          btnPlace.textContent = '';
          this.renderButton(btnPlace);
        }
        return;
      }

      this.removeElement();
    });
  }

  private removeElement() {
    // if (this.el && this.el.nativeElement && this.el.nativeElement.parentNode) {
    //   this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
    // }
  }

  // Obsługa kliknięcia w przycisk
  @HostListener('click')
  onClick() {
    this.signIn(this.provider);
  }

  // Funkcja logowania (powinna być zaimplementowana w serwisie autoryzacji)
  signIn(provider: string) {
    this.buttonClick.emit(provider);
  }
}
